import { Component, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { LoginService } from '../services/login/login.service';
import { LoginModel } from '../models/user/login-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { CookieService } from 'ngx-cookie-service';
import { Router } from "@angular/router";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
/** login component*/
export class LoginComponent {
    /** login ctor */
  isSubmitted = true;
  loginModel : LoginModel = new LoginModel();
  constructor(private readonly loginService: LoginService, public toastr: ToastsManager, private readonly router: Router,
    private cookieService: CookieService, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
    this.isSubmitted = true;
  }

  ngSubmit() {
    this.isSubmitted = false;
    this.loginService.authenticateLogin(this.loginModel).subscribe(
      data => {
        if (data.status == 200) {

          this.cookieService.set('Login', data.data);
          this.toastr.success('Login successfully.', 'Success');
          setTimeout(() => {
            this.router.navigate(["/"]);
          }, 2000);
        }
        else {
          this.isSubmitted = true;
          this.toastr.error(data.message, 'Error');
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts